import * as yup from "yup";
export const SubsidyDocumentsSchema = yup.object().shape({
  clientId: yup.string(),
  aadharcardPhotoFront: yup.mixed(),
  aadharcardPhotoBack: yup.mixed(),
  workOrder: yup.mixed(),
  cibilReport: yup.mixed(),
  ITRReport: yup.mixed(),
  castCertificate: yup.mixed(),
  farmerCertificate: yup.mixed(),
  rentalDocuments: yup.mixed(),
  appliedForAIF: yup.boolean(),
});
